import styled from 'styled-components';

export const HeaderH2 = styled.h2`
  font-size: 1.75rem;
  color: ${Styles.color.white};
  margin: 0;
  padding: 0.65rem 0 0.8rem 0;
  max-width: 300px;
  line-height: 1;
  ${Styles.desktop`
    font-size: 2rem;
  `}
`;

export const HeaderH3 = styled.h3`
  font-size: 1.25rem;
  color: ${Styles.color.white};
  max-width: 300px;
  margin: 0;
  padding: 0;
  line-height: 1;
  ${Styles.desktop`
    font-size: 2rem;
  `}
`;

export const HeaderP = styled.p`
  line-height: 1;
  text-align: left;
  color: ${Styles.color.white};
`;

export const HeaderStrong = styled.strong`
  color: ${Styles.color.white};
  font-weight: ${Styles.fontWeight.black};
`;

export const HeaderEm = styled.em`
  color: ${Styles.color.white};
  font-weight: ${Styles.fontWeight.normal};
  text-align: left;
`;
